/**
* @file Process steps carousel (mobile)
*/

import Slider from 'integration-common-files/src/js/03-organisms/carousel/slider';

export default function loadProccessStepsCarousel(){
  const carousel = document.querySelector('.process-steps__carousel');
  if(carousel) {
    new Slider({
      selector: '.process-steps__carousel',
      controls: false,
      responsive:{
        768: {
          disable: true
        }
      }
    })
  }
};
